// import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
// import { MsalProvider } from '@azure/msal-react';
// import { Provider } from 'react-redux';
// import store from './redux/store';
// import { AuthenticatedTemplate, UnauthenticatedTemplate } from '@azure/msal-react';
// import { useState } from 'react';
// import './App.css';
// // import ProjectDetails from "./components/project/projectDetails";
// // import AttributeLookUpList from "./components/attributeLookup/attributeList";
// import ModuleSelectionDashboard from './shared/moduleSelectionDashboard';
// import PageLayoutCRM from './components/common/PageLayoutCRM';
// import ProtectedPagesCRM, { wrapperCrmPaths } from './routes/ProtectedPagesCRM';
// import GenericPages from './routes/GenericPages';
// import { SelectionPage } from './routes/SelectionPage';
// import Loader from './shared/component/Loader';
// import NotFound from './shared/component/NotFound';
// import AccessDenied from './shared/component/AccessDenied';
// // ✅ Import React Toastify
// import { ToastContainer, toast } from 'react-toastify';

// /**
//  * msal-react is built on the React context API and all parts of your app that require authentication must be
//  * wrapped in the MsalProvider component. You will first need to initialize an instance of PublicClientApplication
//  * then pass this to MsalProvider as a prop. All components underneath MsalProvider will have access to the
//  * PublicClientApplication instance via context as well as all hooks and components provided by msal-react. For more, visit:
//  * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
//  */
// const App = ({ instance }) => {
//   const [userPermission, setUserPermission] = useState();
//   // const [isCrmModulePermission, setIsCrmModulePermission] = useState(false);
//   // const [isTimetrackModulePermission, setIsTimetrackModulePermission] =
//   //   useState(false);
//   // const location = useLocation();

//   const getUserDetail = (obj) => {
//     // setIsCrmModulePermission(obj.isCRMAccessible);
//     // setIsTimetrackModulePermission(obj.isTimetrackAccessible);
//   };
//   const getUserPermissions = (obj, tree) => {
//     let data = { menues: obj?.menues, role: obj?.role, menuTree: tree };
//     setUserPermission(data);
//   };

//   const renderRoutes = () => {
//     <Routes>
//       <Route path="/" element={<Navigate to="/dashboard" replace />} />
//       {/* <Route path="/dashboard" element={<ModuleSelectionDashboard />} /> */}
//       <Route path="*" element={<NotFound />} />
//       <Route path="/unauthorized" element={<AccessDenied />} />
//     </Routes>;
//   };

//   return (
//     <MsalProvider instance={instance}>
//       <ToastContainer />
//       <AuthenticatedTemplate>
//         <Provider store={store}>
//           <SelectionPage instance={instance} userDetail={getUserDetail}>
//             <PageLayoutCRM instance={instance} userPermissions={getUserPermissions}>
//               <ProtectedPagesCRM userPermission={userPermission} />
//             </PageLayoutCRM>
//           </SelectionPage>
//         </Provider>
//       </AuthenticatedTemplate>
//       <UnauthenticatedTemplate>
//         <GenericPages />
//       </UnauthenticatedTemplate>
//     </MsalProvider>
//   );
// };

// export default App;














import { MsalProvider } from "@azure/msal-react";
import { Provider } from "react-redux";
import { useState } from "react";
import store from "./redux/store";
import "./App.css";
import PageLayoutCRM from "./components/common/PageLayoutCRM";
import ProtectedPagesCRM, { wrapperCrmPaths } from './routes/ProtectedPagesCRM';
import { SelectionPage } from "./routes/SelectionPage";
import { ToastContainer } from "react-toastify";
import { AppAuthProvider } from "./auth/appAuthContext";
import AuthGuard from "./auth/authGuard";

const App = ({ instance }) => {
  const [userPermission, setUserPermission] = useState();
  const [isTimetrackModulePermission, setIsTimetrackModulePermission] =
    useState(false);
  // let WrapperComponent = <PageLayoutCRM></PageLayoutCRM>;

  const getUserDetail = (obj) => {
    setIsTimetrackModulePermission(obj.isTimetrackAccessible);
  };

  const getUserPermissions = (obj) => {
    setUserPermission({ menues: obj?.menues, role: obj?.role });
  };

  return (
    <MsalProvider instance={instance}>

      <AppAuthProvider>
        <ToastContainer position="top-right" theme="colored" />
        <AuthGuard>

          <Provider store={store}>
            <SelectionPage instance={instance} userDetail={getUserDetail}>

              <PageLayoutCRM
                instance={instance}
                userPermissions={getUserPermissions}
              >
                {userPermission && (
                  <ProtectedPagesCRM userPermission={userPermission} />
                )}
              </PageLayoutCRM>
            </SelectionPage>
          </Provider>
        </AuthGuard>
      </AppAuthProvider>
    </MsalProvider >
  );
};

export default App;
